import { useSearchActions, useSearchState } from '../../stores/search'

import { CargoMarkResult } from '@/services/SearchService'

const MarkCard = () => {
  const { searchResult } = useSearchState()
  const { setQuerySearch, fetchQueryResult } = useSearchActions()

  // 类型断言确保 searchResult 是 CargoMarkResult 类型
  const markResult = searchResult as CargoMarkResult

  // 在 searchResult 或关键数据不存在时，显示加载或空状态，防止渲染错误
  if (!markResult) {
    return (
      <div className="text-center text-gray-500 py-10">
        请输入提货唛头码进行搜索...
      </div>
    )
  }

  // 处理托盘点击事件
  const handlePalletClick = (palletCode: string) => {
    console.log('点击托盘:', palletCode)
    // 这里可以添加跳转到托盘详情页面或其他操作
    setQuerySearch(palletCode)
    fetchQueryResult()
  }

  const handlePositionClick = (positionCode: string) => {
    // 这里可以添加跳转到托盘详情页面或其他操作
    setQuerySearch(positionCode)
    fetchQueryResult()
  }

  return (
    <>
      <div className="divide-y divide-dashed divide-gray-300">
        <div className="flex justify-between py-3">
          <span className="text-sm font-medium text-gray-600">分提单号</span>
          <span className="text-sm font-semibold text-gray-900">
            {markResult.houseBill.houseBlNumber}
          </span>
        </div>

        <div className="flex justify-between py-3">
          <span className="text-sm font-medium text-gray-600">箱货总数</span>
          <span className="text-sm font-semibold text-gray-900">
            {markResult.quantity} / {markResult.packages}
          </span>
        </div>

        {/* <div className="flex justify-between items-center py-3">
          <span className="text-sm font-medium text-gray-600">箱货状态</span>
          <div className="flex gap-3 items-center">
            <div className="flex items-center gap-1">
              <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
              <span className="text-xs text-gray-600">待处理</span>
              <span className="text-sm font-semibold text-yellow-600">
                {markResult.boxes_info.pending}
              </span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
              <span className="text-xs text-gray-600">已扫描</span>
              <span className="text-sm font-semibold text-blue-600">
                {markResult.boxes_info.scanned}
              </span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-2 h-2 bg-green-500 rounded-full"></span>
              <span className="text-xs text-gray-600">已入库</span>
              <span className="text-sm font-semibold text-green-600">
                {markResult.boxes_info.warehoused}
              </span>
            </div>
          </div>
        </div> */}

        {/* 托盘列表 */}
        {markResult.pallets && markResult.pallets.length > 0 && (
          <div className="">
            <div className="flex justify-between py-3 ">
              <span className="text-sm font-medium text-gray-600">
                托盘详情
              </span>
              <span className="text-sm font-semibold text-gray-900">
                {markResult.pallets.length}
              </span>
            </div>
            {markResult.pallets.map((pallet, index) => (
              <div
                key={index}
                className="ml-4 space-y-2 border-l-2 border-gray-200 pl-4 mb-4 divide-y divide-dashed divide-gray-300"
              >
                <div className="flex justify-between py-2">
                  <span className="text-sm font-medium text-gray-600">
                    托盘编号
                  </span>
                  <span
                    className="text-sm font-semibold text-blue-600 hover:text-blue-800 cursor-pointer underline"
                    onClick={() => handlePalletClick(pallet.palletCode)}
                  >
                    {pallet.palletCode}
                  </span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="text-sm font-medium text-gray-600">
                    状态
                  </span>
                  <span className="text-sm font-semibold text-gray-900">
                    {pallet.statusDisplay}
                  </span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="text-sm font-medium text-gray-600">
                    箱货数量
                  </span>
                  <span className="text-sm font-semibold text-gray-900">
                    {pallet.quantity}
                  </span>
                </div>

                {pallet.warehousePosition && (
                  <div className="flex justify-between items-center py-3 ">
                    <span className="text-sm font-medium text-gray-600">
                      库位编号
                    </span>
                    <span
                      className="text-sm font-semibold  text-blue-600 hover:text-blue-800 cursor-pointer underline"
                      onClick={() =>
                        handlePositionClick(pallet.warehousePosition.code)
                      }
                    >
                      {pallet.warehousePosition.name}
                    </span>
                  </div>
                )}

                {/*<div className="flex justify-between py-2">
                  <span className="text-sm font-medium text-gray-600">
                    库位编号
                  </span>
                  <span className="text-sm font-semibold text-gray-900">
                    {pallet.warehousePosition?.code || '未分配'}
                  </span>
                </div>*/}
              
                {/* {pallet.entry_date && (
                  <div className="flex justify-between py-2">
                    <span className="text-sm font-medium text-gray-600">
                      入库时间
                    </span>
                    <span className="text-sm font-semibold text-gray-900">
                      {new Date(pallet.entry_date).toLocaleDateString()}
                    </span>
                  </div>
                )} */}
                {/* {pallet.exit_date && (
                  <div className="flex justify-between py-2">
                    <span className="text-sm font-medium text-gray-600">
                      出库时间
                    </span>
                    <span className="text-sm font-semibold text-gray-900">
                      {new Date(pallet.exit_date).toLocaleDateString()}
                    </span>
                  </div>
                )} */}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}

export default MarkCard
